var __WEBPACK_NAMESPACE_OBJECT__ = ReactI18next;